import {
    STREAMING_PLATFORM_DATA,
    StreamingPlatform
} from '~/components/Builder/Block/VideoBlock/VideoBlock.types';

export const detectStreamingPlatformFromUrl = (
    url: string
): StreamingPlatform => {
    const domainRegexOptions = Object.values(STREAMING_PLATFORM_DATA)
        .map(stream => stream.domainRegex)
        .join('|');

    const streamingTypeRegex = new RegExp(
        `(https?:\/\/|\/\/|)(player.|www.)?(${domainRegexOptions})\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?`
    );

    const matchedTypes = url.match(streamingTypeRegex);
    const detectedServiceItem = Object.keys(STREAMING_PLATFORM_DATA).find(
        (platform: StreamingPlatform) => {
            const streamingPlatform = STREAMING_PLATFORM_DATA[platform];
            let isDetected =
                matchedTypes?.[3]?.indexOf(streamingPlatform.regexTerm) > -1;

            if (streamingPlatform.customValidtion && !isDetected) {
                isDetected = streamingPlatform.customValidtion(url);
            }
            return isDetected;
        }
    ) as StreamingPlatform;
    return detectedServiceItem;
};
